import { Routes, Route } from 'react-router-dom';
import LoginPage from '../pages/LoginPage';
import HomePage from '../pages/HomePage';
import CarListingPage from '../pages/CarListingPages';
import CarDetailPage from '../pages/CarDetailPage_2';
import AboutPage from '../pages/AboutPage';
import NotFoundPage from '../pages/NotFoundPage';
import DealerVehicleListing from '../pages/DealerVehicleListing';
import DealerPage from '../pages/dealers';
import SellPage from '../pages/sellVehiclePage';
import VehicleSuccessPage from '../pages/VehicleSuccessPage';
import ContactUsPage from '../pages/ContactUsPage';

// ✅ Newly added pages
import TermsPage from '../pages/TermsPage';
import PrivacyPage from '../pages/PrivacyPage';

interface AppRoutesProps {
  mode: 'light' | 'dark';
  setMode: (mode: 'light' | 'dark') => void;
}

const AppRoutes = ({ mode, setMode }: AppRoutesProps) => {
  return (
    <Routes>
      <Route path="/" element={<HomePage mode={mode} setMode={setMode} />} />
      <Route path="/home" element={<HomePage mode={mode} setMode={setMode} />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/vehicle-listing" element={<CarListingPage mode={mode} setMode={setMode} />} />
      <Route path="/car-details/:id" element={<CarDetailPage mode={mode} setMode={setMode} />} />
      <Route path="/dealer-vehicles/:id" element={<DealerVehicleListing mode={mode} setMode={setMode} />} />
      <Route path="/about" element={<AboutPage mode={mode} setMode={setMode} />} />
      <Route path="/dealer-vehicles" element={<DealerPage mode={mode} setMode={setMode} />} />
      <Route path="/sell-vehicle" element={<SellPage mode={mode} setMode={setMode} />} />
      <Route path="/vehicle-success" element={<VehicleSuccessPage mode={mode} setMode={setMode} />} />
      <Route path="/contact-us" element={<ContactUsPage mode={mode} setMode={setMode} />} />

      {/* ✅ Newly added routes */}
      <Route path="/Terms" element={<TermsPage mode={mode} setMode={setMode} />} />
      <Route path="/Privacy" element={<PrivacyPage mode={mode} setMode={setMode} />} />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
